import { useQuery } from '@tanstack/react-query';

import { queryFn } from './queryFn';

type Args = {
  id: string;
  size?: number;
};
/**
 * ## Description
 *
 * A hook that returns a companies historical price targets as decided by analysts.
 *
 * ### Params
 * 1. `id` - The `company.id` to select
 * 2. `size` - The amount of historical data points required
 *
 * ### Returns
 *```
 *  priceTargetHistory: {
 *    fromDate: number | null;
 *    toDate: number | null;
 *    consensusMean: number | null;
 *    currencyISO: string;
 *  }[];
 * ```
 */
export const useCompanyPriceTargetHistory = ({ id, size }: Args) => {
  const query = useQuery({
    queryKey: ['COMPANY_PRICE_TARGET_HISTORY', id, size],
    queryFn,
    staleTime: 3600000,
  });
  return query;
};
